export default __webpack_public_path__ + "static/team-eric-a798e191fc00063f67eea17f8f20c1a3.png";